export type MainTopicType = 'reuseCO2' | 'reduceMaterials' | 'reduceCO2' | 'reuseMaterials'

export const reduceMaterialsArray = ['ProductsUsingLessMaterial', 'Special3DConcretePrinting', 'UHPCs'] as const;
export type ReduceMaterialsType = typeof reduceMaterialsArray[number];

export const reduceCO2Array = ['CarbonReducedProducts', 'SubstitutingClinkerWithFlyAsh', 'SubstitutingClinkerWithCalcineClay'] as const;
export type ReduceCO2Type = typeof reduceCO2Array[number];

export const reuseMaterialsArray = ['CircularProducts', 'ConcreteModulesConcrete', 'ConcreteRecycledAggregates'] as const;
export type ReuseMaterialsType = typeof reuseMaterialsArray[number];

export const reuseCO2Array = ['DecarbonisedProducts', 'BrevikCCS', 'LengfurtCCU'] as const;
export type ReuseCO2Type = typeof reuseCO2Array[number];



export type SustainabilityCommitments2030Type = 'sustainabilityCommitments2030';

export type CategoryType = ReduceMaterialsType | ReuseMaterialsType | ReuseCO2Type | ReduceCO2Type | SustainabilityCommitments2030Type;


export type CategoryArrayType = typeof reuseMaterialsArray | 
typeof reduceMaterialsArray | 
typeof reuseCO2Array | 
typeof reduceCO2Array

export type Breakpoints = {
  isMobile: string,
  isTablet: string,
  isDesktopSmall?: string,
  isDesktop: string,
  isFourK?: string,
};

